var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "j-form-container",
            { attrs: { disabled: _vm.formDisabled } },
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    slot: "detail",
                    model: _vm.model,
                    size: "small",
                    "label-col": _vm.labelCol1,
                    "wrapper-col": _vm.wrapperCol1,
                    rules: _vm.validatorRules
                  },
                  slot: "detail"
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.areacode"],
                                prop: "areacode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language["cs.areacode"],
                                  maxLength: 20
                                },
                                model: {
                                  value: _vm.model.areacode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "areacode", $$v)
                                  },
                                  expression: "model.areacode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.areaname"],
                                prop: "areaname"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language["cs.areaname"],
                                  maxLength: 100
                                },
                                model: {
                                  value: _vm.model.areaname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "areaname", $$v)
                                  },
                                  expression: "model.areaname"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.maxrowqty"],
                                prop: "maxRowQty"
                              }
                            },
                            [
                              _c("a-input-number", {
                                attrs: {
                                  min: 1,
                                  placeholder: this.language["cs.maxrowqty"]
                                },
                                model: {
                                  value: _vm.model.maxRowQty,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "maxRowQty", $$v)
                                  },
                                  expression: "model.maxRowQty"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.maxcolqty"],
                                prop: "maxColQty"
                              }
                            },
                            [
                              _c("a-input-number", {
                                attrs: {
                                  min: 1,
                                  placeholder: this.language["cs.maxcolqty"]
                                },
                                model: {
                                  value: _vm.model.maxColQty,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "maxColQty", $$v)
                                  },
                                  expression: "model.maxColQty"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.sort"],
                                prop: "sort"
                              }
                            },
                            [
                              _c("a-input-number", {
                                attrs: {
                                  min: 1,
                                  placeholder: this.language["common.sort"]
                                },
                                model: {
                                  value: _vm.model.sort,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "sort", $$v)
                                  },
                                  expression: "model.sort"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.uploadPicture"],
                                labelCol: _vm.labelCol1,
                                wrapperCol: _vm.wrapperCol1,
                                prop: "files"
                              }
                            },
                            [
                              _c("j-image-upload", {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  text: "上传",
                                  "upload-source": _vm.uploadSource,
                                  isMultiple: true,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.files,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "files", $$v)
                                  },
                                  expression: "model.files"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }